//
//
//
//
//
//
//
//
import { DateMixin } from '@/mixins/DateMixin';
export default {
  name: 'weekRange',
  mixins: [DateMixin],
  mounted: function mounted() {
    console.log(this.startWeek);
    console.log(this.endWeek);
    this.$emit('change', [this.weekFormatFunStr(this.startWeek), this.weekFormatFunStr(this.endWeek)]);
  },
  methods: {
    // 开始周变化
    onweekChange1: function onweekChange1(value) {
      this.startWeek = value;
      var startTime = this.weekFormatFun(this.startWeek);
      var endTime = this.weekFormatFun(this.endWeek);

      if (startTime[0] == endTime[0]) {
        if (startTime[1] >= endTime[1]) {
          this.startWeek = "";
          this.$message.error('开始周必须小于结束周');
          return;
        }
      } else if (startTime[0] > endTime[0]) {
        this.startWeek = "";
        this.$message.error('开始周必须小于结束周');
        return;
      }

      this.$emit('change', [this.weekFormatFunStr(this.startWeek), this.weekFormatFunStr(this.endWeek)]);
    },
    // 结束周变化
    onweekChange2: function onweekChange2(value) {
      this.endWeek = value;
      var startTime = this.weekFormatFun(this.startWeek);
      var endTime = this.weekFormatFun(this.endWeek);

      if (startTime[0] == endTime[0]) {
        if (startTime[1] >= endTime[1]) {
          this.endWeek = "";
          this.$message.error('开始周必须小于结束周');
          return;
        }
      } else if (startTime[0] > endTime[0]) {
        this.endWeek = "";
        this.$message.error('开始周必须小于结束周');
        return;
      }

      this.$emit('change', [this.weekFormatFunStr(this.startWeek), this.weekFormatFunStr(this.endWeek)]);
    }
  }
};